import { IconProps } from "../../../types/style";

const NationalCardSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
      >
        <path
          d="M9 2H3C1.895 2 1 2.89 1 3.985V9.015C1 10.11 1.895 11 3 11H9C10.105 11 11 10.11 11 9.015V3.985C11 2.89 10.105 2 9 2ZM4.25 4.085C4.885 4.085 5.405 4.605 5.405 5.24C5.405 5.875 4.885 6.395 4.25 6.395C3.615 6.395 3.095 5.875 3.095 5.24C3.095 4.605 3.615 4.085 4.25 4.085ZM6.185 8.83C6.14 8.88 6.07 8.91 6 8.91H2.5C2.43 8.91 2.36 8.88 2.315 8.83C2.27 8.78 2.245 8.71 2.25 8.64C2.335 7.8 3.005 7.135 3.845 7.055C4.11 7.03 4.385 7.03 4.65 7.055C5.49 7.135 6.165 7.8 6.245 8.64C6.255 8.71 6.23 8.78 6.185 8.83ZM9.5 8.875H8.5C8.295 8.875 8.125 8.705 8.125 8.5C8.125 8.295 8.295 8.125 8.5 8.125H9.5C9.705 8.125 9.875 8.295 9.875 8.5C9.875 8.705 9.705 8.875 9.5 8.875ZM9.5 6.875H7.5C7.295 6.875 7.125 6.705 7.125 6.5C7.125 6.295 7.295 6.125 7.5 6.125H9.5C9.705 6.125 9.875 6.295 9.875 6.5C9.875 6.705 9.705 6.875 9.5 6.875ZM9.5 4.875H7C6.795 4.875 6.625 4.705 6.625 4.5C6.625 4.295 6.795 4.125 7 4.125H9.5C9.705 4.125 9.875 4.295 9.875 4.5C9.875 4.705 9.705 4.875 9.5 4.875Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default NationalCardSVG;
